import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle.js';
import { useNavigate } from 'react-router-dom';
import { Home, Library, Compass } from 'lucide-react';
import { Button } from '../components/ui/Button.js';
import { useAuthStore } from '../stores/authStore.js';

export const NotFoundPage: React.FC = () => {
  usePageTitle('صفحه پیدا نشد');
  const navigate = useNavigate();
  const { isAuthenticated, isGuest } = useAuthStore();
  const homeTarget = isAuthenticated || isGuest ? '/dashboard' : '/';

  return (
    <main
      id="content"
      data-testid="not-found-page"
      className="min-h-screen bg-base-100 text-base-content flex flex-col items-center justify-center p-4 selection:bg-primary selection:text-white"
      dir="rtl"
    >
      <div className="w-full max-w-md text-center flex flex-col items-center">
        {/* Visual Badge & Icon */}
        <div className="relative mb-6">
          <div className="size-24 rounded-3xl bg-neutral/80 border border-base-300 flex items-center justify-center shadow-xl">
            <Compass className="size-12 text-primary animate-pulse" />
          </div>
          <span className="absolute -bottom-2 -start-2 px-2.5 py-0.5 rounded-full bg-error text-error-content font-mono font-bold text-xs shadow-md">
            404
          </span>
        </div>

        {/* Heading & Description */}
        <h1 className="text-2xl md:text-3xl font-extrabold text-base-content mb-3">
          صفحهٔ مورد نظر پیدا نشد
        </h1>
        <p className="text-sm md:text-base text-base-content/70 leading-relaxed max-w-sm mb-8">
          آدرسی که وارد کردید جابه‌جا شده یا وجود ندارد. می‌توانید به داشبورد برگردید یا کتابخانه تبلچرها را بررسی کنید.
        </p>

        {/* Navigation Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 w-full sm:w-auto">
          <Button
            variant="primary"
            size="md"
            icon={<Home className="size-4" />}
            onClick={() => navigate(homeTarget)}
            data-testid="not-found-home-button"
            className="w-full sm:w-auto"
          >
            {isAuthenticated || isGuest ? 'بازگشت به داشبورد' : 'بازگشت به صفحهٔ اصلی'}
          </Button>

          <Button
            variant="secondary"
            size="md"
            icon={<Library className="size-4" />}
            onClick={() => navigate('/tabs')}
            data-testid="not-found-library-button"
            className="w-full sm:w-auto"
          >
            کتابخانه تبلچرها
          </Button>
        </div>
      </div>
    </main>
  );
};

export default NotFoundPage;
